module.exports = __webpack_public_path__ + "3695dcc53cd82711d12bedfc73ef5d50.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/jiankang_c.png
// module id = 254
// module chunks = 3